/* eslint-disable */
import cookie from 'react-cookie';
const config = require('./config');
const lang = require('./lang');
import { hashHistory } from 'react-router';
import axios from 'axios';
const APPID = config.ids.appId;
const APIURL = config.path.apiUrl;
const APIURLPRO = config.path.apiUrlPro;
var qs = require('qs');
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser();
const apps = require('./apps');
import moment from "moment";
import { orderBy, isEmpty } from "lodash";
/* address format */
exports.addressFormat = function (unitOne, unitTwo, addressOne, addressTwo, postCode) {
	var unit = (unitTwo !== "" && unitOne !== "" ? "#" + unitOne + "-" + unitTwo + "," : (unitOne !== '' ? "#" + unitOne + "," : ""));
	return unit + addressOne;
};

/* set default avilablity  */
exports.setDefaultAvailability = function (avlId, avlText, avlImage) {
	if ((typeof cookie.load('defaultAvilablityId') === 'undefined' || cookie.load('defaultAvilablityId') === "") || (typeof cookie.load('defaultAvilablity') === 'undefined' || cookie.load('defaultAvilablity') === "") || (typeof cookie.load('defaultAvilablityImage') === 'undefined' || cookie.load('defaultAvilablityImage') === "")) {
		cookie.save('defaultAvilablityId', avlId, {});
		cookie.save('defaultAvilablity', avlText, {});
		cookie.save('defaultAvilablityImage', avlImage, {});
	}


};

exports.loadingImage = function () {
	return "<div style={{bottom : 0, left: 0, position: 'fixed', right : 0,  top : 0, margin :'auto'}}> <img src='/img/loader.gif' alt=''  style={{bottom : 0, left: 0, position: 'fixed', right : 0,  top : 0, margin :'auto'}} /> </div>";
}

/* this function used to show unit */
exports.unitFormat = function (noOne, noTwo) {
	if (noOne != '' && noTwo != "") {
		return "#" + noOne + "-" + noTwo;
	} else if (noOne != "") {
		return "#" + noOne;
	}
	else if (noTwo != "") {
		return noTwo;
	}

};

/* this function used for static table setup sarvesh */
exports.sarveshTableSetup = function () {

	var postObject = {};
	postObject = { 'app_id': APPID, 'tm_table_number': 'Wavehouse' }
	axios.post(APIURL + "tablemanagement/find_table", qs.stringify(postObject)).then(res => {
		if (res.data.status === "ok") {
			cookie.save('orderOutletId', res.data.result_set[0].outlet_id);
			cookie.save('orderOutletName', res.data.result_set[0].outlet_name);
			cookie.save('orderTableNo', res.data.result_set[0].tm_table_number);
			var tatVal = (res.data.result_set[0].outlet_dine_tat !== "" ? res.data.result_set[0].outlet_dine_tat : res.data.result_set[0].outlet_delivery_timing)
			cookie.save('orderTAT', tatVal);
			if (cookie.load('dineinClick') === 'yes') {
				hashHistory.push("/");
			} else {
				hashHistory.push("/checkout");
			}
		}
		else if (res.data.status === "error") {
			cookie.save('orderOutletId', '76');
			cookie.save('orderOutletName', 'Thaikkudam Bridge');
			cookie.save('orderTableNo', 'Wavehouse');
			cookie.save('orderTAT', '15');
			hashHistory.push("/checkout");
			if (cookie.load('dineinClick') === 'yes') {
				hashHistory.push("/");
			} else {
				hashHistory.push("/checkout");
			}
		}
	});

};

/* check vaild input */
exports.validInput = function (inPut) {
	if ((typeof cookie.load('defaultAvilablityId') === 'undefined')) {

	}
};

/* shop timing  funtion */
exports.shopTiming = function (start, end) {
	if ((typeof start !== "undefined" && start !== "") && (typeof end !== "undefined" && end !== "")) {
		return start + " - " + end;
	}
};

/* shop timing  funtion */
exports.defauktImage = function (availId) {
	if ((typeof start !== "undefined" && start !== "") && (typeof end !== "undefined" && end !== "")) {
		return start + " - " + end;
	}
};

/* sample funtion */
exports.findDevice = function () {

	if (navigator.userAgent.match(/Android/i)
		|| navigator.userAgent.match(/webOS/i)
		//|| navigator.userAgent.match(/iPhone/i)
		//|| navigator.userAgent.match(/iPad/i)
		//|| navigator.userAgent.match(/iPod/i)
		|| navigator.userAgent.match(/BlackBerry/i)
		|| navigator.userAgent.match(/Windows Phone/i)
	) {
		return "Others";

	}
	else if (
		navigator.userAgent.match(/iPhone/i)
		|| navigator.userAgent.match(/iPad/i)
		|| navigator.userAgent.match(/iPod/i)
	) {
		return "IOS";
	}

	else {

		return "Web";
	}

};


/* sample funtion */
exports.getGstValue = function (gst, subtotal, format) {

	var gst = parseFloat(gst);
	var subtotal = parseFloat(subtotal);
	var gstResult = 0;

	if (gst > 0) {
		gstResult = (gst / 100) * subtotal;
	}

	if (format === "format") {
		return gstResult.toFixed(2);
	} else {
		return gstResult;
	}

};

/* gstInclusive  amount funtion */
exports.getInclusiveGst = function (gstVal, total, format) {
	if (gstVal > 0) {
		var vatDivisor = 1 + (gstVal / 100);
		var gstpercentage = gstVal / 100;
		var productvalue = total / vatDivisor
		var gst = productvalue * gstpercentage;
		var return_data = "GST Inclusive" + "(" + gstVal + "%): $" + gst.toFixed(2);
	} else {
		var return_data = '';
	}

	return return_data;
};


/* sample funtion */
exports.getServicecharge = function (service_percent, total_amt, format) {

	var service_percent = parseFloat(service_percent);
	var total_amt = parseFloat(total_amt);
	var cal_amount = 0;

	if (service_percent > 0) {
		cal_amount = (service_percent / 100) * total_amt;
	}

	if (format === "format") {
		return cal_amount.toFixed(2);
	} else {
		return cal_amount;
	}

};


/*
 
showInfo(alrtmessage,alertheader)
{
$('.alrt_overlay').remove();
$('.custom_alert').remove();

alertheader =  (typeof(alertheader) =="undefined" )?  "Information" :  alertheader;


   $('body').append('<div class="alrt_overlay"></div><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">'+ alertheader +'</div><div class="alert_body"> '+ alrtmessage +' <div class="alt_btns"><a href="javascript:;" class="btn btn-info reject" id="alt0">Close</a></div></div></div></div></div>');
	
	   var actheight=$('.alert_height').height();
	   $('.custom_alert').height(actheight+10);
   
	
   $('.alt_btns a').click(function(e) {
	  $('.alrt_overlay, .custom_alert').remove();
	  
   });
} 
 
*/
exports.showInfo = function (alrtmessage, alertheade) {


	$('.alrt_overlay').remove();
	$('.custom_alert').remove();

	var alertheader = (typeof (alertheader) == "undefined") ? "Information" : alertheader;


	$('body').append('<div class="alrt_overlay"></div><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">' + alertheader + '</div><div class="alert_body"> ' + alrtmessage + ' <div class="alt_btns"><a href="javascript:;" class="btn btn-info reject" id="alt0">Close</a></div></div></div></div></div>');

	var actheight = $('.alert_height').height();
	$('.custom_alert').height(actheight + 10);


	$('.alt_btns a').click(function (e) {
		$('.alrt_overlay, .custom_alert').remove();

	});

};

exports.confirmAlert = function (alrtmessage, alertheader) {

	$('.alrt_overlay').remove();
	$('.custom_alert').remove();

	var alertheader = (typeof (alertheader) == "undefined") ? "Confirmation" : alertheader;

	$('body').append('<div class="alrt_overlay"></div><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">' + alertheader + '</div><div class="alert_body"> ' + alrtmessage + ' <div class="alt_btns"><a href="javascript:;" class="btn btn-primary confirm" id="alt1">OK</a><a href="javascript:;" class="btn btn-info reject" id="alt0">Cancel</a></div></div></div></div></div>');

	var actheight = $('.alert_height').height();
	$('.custom_alert').height(actheight + 10);


	$('.alt_btns a').click(function (e) {
		$('.alrt_overlay, .custom_alert').remove();

	});

};


/*  get pro settings */
exports.getProSettings = function (allowPostalcode, postalFilter) {

	if (allowPostalcode === "Yes") {
		var postalStr = "&postal_code=" + cookie.load('orderPostalCode');
	} else {
		postalStr = "";
	}
	var postalFilter = (postalFilter === "Yes" ? "Yes" : "No");
	return axios.get(APIURLPRO + 'settings/get_common_settings?app_id=' + APPID + postalStr + "&postalFilter=" + postalFilter);

};


/* get static block content */
exports.getStaticBlock = function (blockSlug) {

	return axios.get(APIURL + 'cms/staticblocks?app_id=' + APPID + "&slug=" + blockSlug);

};

/* sample funtion */
exports.getAliasName = function (alias, productName) {

	return (alias != "" ? alias : productName)
};

/* get subtotal value  */
exports.getsubTotal = function (subTotal, OriginalAmount, promotionApplied, redeemptionApplied = null) {

	if (promotionApplied === "Yes") {
		return subTotal;
	} else if (redeemptionApplied === "Yes") {
		return subTotal;
	} else {
		return OriginalAmount;
	}

};


/* get subtotal value  */
exports.getDeliveryCharge = function (promotionApplied, deliveryEnabled, OriginalAmount, isFreeDelivery = null) {

	if ((promotionApplied === "Yes" && deliveryEnabled === "Yes") || isFreeDelivery === "Yes") {
		return 0;
	} else {
		return OriginalAmount;
	}

};

/* get subtotal value  */
exports.getAdditionalDeliveryCharge = function (promotionApplied, deliveryEnabled, OriginalAmount, isFreeDelivery = null) {

	if ((promotionApplied === "Yes" && deliveryEnabled === "Yes") || isFreeDelivery === "Yes") {
		return 0;
	} else {
		return OriginalAmount;
	}

};

/* Show cart count  */
exports.cartCount = function () {

	var count = parseInt(cookie.load('cartCount'));

	if (cookie.load('cartValue') === "Yes" && typeof cookie.load('cartCount') !== 'undefined' && count > 0) {

		return htmlToReactParser.parse('<span className="count">' + count + '</span>');
	}
};


/* Show cart class   */
exports.cartClass = function () {

	var count = parseInt(cookie.load('cartCount'));

	if (cookie.load('cartValue') === "Yes" && typeof cookie.load('cartCount') !== 'undefined' && count > 0) {

		return "rel cart-icon bounce";
	} else {

		return "rel cart-icon";
	}
};

/* add body tag class for workspace */
exports.addBodyClass = function (appId) {

	if (APPID === apps.workspace) {
		document.body.className += ' ' + 'workspace-css';
	}


};


/* sample funtion */
exports.myFunc2 = function () { return "wellcome1" };


exports.alphabet = function (e) {
	const re = /^[a-zA-Z. ]*$/;
	if (!re.test(e.key)) {
		e.preventDefault();
	}
}

exports.numariconly = function (e) {
	const re = /[0-9. ]+/g;
	if (!re.test(e.key)) {
		e.preventDefault();
	}
}
/* distance part */
exports.getSortedList = function (obj, coordinate) {
	let returnValue = {};
	const coordinateVal = coordinate;
	if (!(isEmpty(obj))) {
		let sortObject = obj.map(option => {
			let distanceVal = distance(option.outlet_marker_latitude, option.outlet_marker_longitude, coordinateVal);
			const newPropsObj = {
				distance: distanceVal
			};
			return Object.assign(option, newPropsObj);
		});
		returnValue = orderBy(sortObject, (data) => {
			return moment(data['distance'])
		}, ['asc']);

	}
	return returnValue;
};


function distance(lat1, lon1, coordinate) {

	if (coordinate) {

		let lat2 = coordinate.latitude;
		let lon2 = coordinate.longitude
		var R = 6371; // km (change this constant to get miles)
		var dLat = (lat2 - lat1) * Math.PI / 180;
		var dLon = (lon2 - lon1) * Math.PI / 180;
		var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
			Math.sin(dLon / 2) * Math.sin(dLon / 2);
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		var d = R * c;
		if (d > 1) return Math.round(d); //km
		else if (d <= 1) return Math.round(d * 1000) + "m";
		return d;
	}
}

/* distance part */

/* truncate  */
exports.truncate = function (input, type ) {
	let windowWidth = window.innerWidth >= 480 ? 100 :  (type ===1 ? 40 : 40);
	if (input && input.length > 0) {
		if (input.length > windowWidth) {
			return input.substring(0, windowWidth) + '...';
		}
		return input;

	} else {
		return "";
	}
};

/* sample funtion */
exports.getTat = function () { };


// WEBPACK FOOTER //
// ./src/Helper.js